<script lang="ts" setup>
import { nodeViewProps } from "@tiptap/vue-3";
import type { FieldDefinition } from "~/models/Automation";

const props = defineProps(nodeViewProps);

const item = computed<FieldDefinition>(() =>
    props.extension.options.getMatch(props.node),
);
</script>

<template>
    <TiptapNodeViewWrapper :data-key="item?.key" :data-label="item?.label" as="span"
        class="inline-flex text-gray-900 hd-field-variable gap-2 py-1 items-center align-middle bg-white truncate max-w-full"
        v-bind="extension.options.HTMLAttributes">
        <template v-if="item">
            <BadgeFieldType size="xs" :label="`${item.metadata.position + 1}.`" variant="badge"
                :type="item.metadata.type" :sub-type="item.metadata.sub_type" badge-size="xs" icon-size="xs" />
            <span class="text-xs">{{
                item.label
                    .replace(item.metadata.label ?? "", "")
                    .replace(`${item.metadata.position}.`, "")
                    .replace(`${item.metadata.position + 1}.`, "")
                    .replaceAll(" ", " ")
                    .trim()
            }}</span>
        </template>
    </TiptapNodeViewWrapper>
</template>
